import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconCamera = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconCamera.dimensions.width} ${IconCamera.dimensions.height}`}
      {...otherProps}
    >
      <G fillRule="nonzero" stroke={color || Color.premiumBlack} fill="none">
        <Path d="M7 10a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z" />
        <Path d="m7.42 1.56-.67.64a2 2 0 0 1-1.38.56H3a1.89 1.89 0 0 0-2 1.75v10.54a1.89 1.89 0 0 0 2 1.76h16a1.89 1.89 0 0 0 2-1.76V4.51a1.89 1.89 0 0 0-2-1.76h-2.37a2 2 0 0 1-1.38-.56l-.67-.64A2 2 0 0 0 13.2 1H8.8a2 2 0 0 0-1.38.56Z" />
      </G>
    </Svg>
  )
}

IconCamera.dimensions = {
  width: 22,
  height: 18,
}

export default IconCamera
